import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { CDSNode } from '../services/capd.model';
import { OrgService } from '../services/org.service';
import {CDSTreeService} from "../services/cds.service";

@Component({
  templateUrl: './user.component.html'
})

/**
 * Host component for the users list.
 */
export class UserComponent implements OnInit, OnDestroy {

  type: string;
  root: string;
  org: CDSNode;
  filter: string;
  @Input() loadingVal: boolean = true;
  userCount: number;
  private sub: any;

  constructor(private _service: OrgService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _cdsTreeService: CDSTreeService) {
  }

  /**
   * Gets the current OID and group.
   *
   * @async
   * @func ngOnInit
   */
  ngOnInit() {
    this.loadingVal = true;
    this.sub = this._route.params.subscribe(params => {
      this.root = params.id;
      const index = this.root.indexOf('+');
      if (index >= 0) {
        this._service.getOrgInfo(this.root).then((org: CDSNode) => this.org = org).then(() => this.loadingVal = false);
      }
      else {
        const split = this.root.split('+');
        this._service.getOrgInfo(this.root).then((org: CDSNode) => {
          this.org = org
        }).then(() => this.loadingVal = false).then(() => {
        if(this.org == undefined) {
          this.loadingVal = true
          this._cdsTreeService.refreshBranchById(this.root).then(groups => console.log(groups)).then(() => {
            this._service.getGroup(split[0], split[1]).then((org: CDSNode) => {
              this.org = org
              // if we still cannot find anything, set a generic empty node to prevent error
              if(this.org == undefined) {
                this.org = new CDSNode();
              }
            }).then(() => this.loadingVal = false);
          })
        }
        })
      }
    });
  }

  /**
   * Sets the search filter string.
   *
   * @func search
   * @param {string} newFilter - the new search filter.
   */
  search(newFilter: string) {
    this.filter = newFilter;
  }

  updateUserCount(userCount: number) {
    this.userCount = userCount;
  }

  setLoading(event) {
    console.log(event);
    this.loadingVal = event;
  }

  /**
   * Destroys the subscriber.
   *
   * @async
   * @func ngOnDestroy
   */
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
